export default __webpack_public_path__ + "static/media/dream-joystick-bridge_1.0.0_amd64.cbcd79d5.deb";